// This is generated code from apps/website/svgs.ts.
// To regenerate this, run `nx build-svgs website`

export const PICTOGRAMS_REMOTE_SPRITE_URL =
    '/pictograms-sprite-804c9e6ee0645fe092099e51c41f0ed48b469babc1a004bfcd134a5dd288d2e9.svg';
